import React from 'react';
import { ImageIcon, StarIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
import { testimonials } from '../data/landing';
export function Testimonials() {
  return <section className="bg-sage-pale px-5 py-14 sm:py-20" data-id="element-134" data-mp="3fycpzlihi3a9">
      <Reveal data-id="element-135" data-mp="3b0ud5k1cj3wz">
        <div className="mb-3 flex justify-center gap-0.5" aria-label="5 estrellas" data-id="element-136" data-mp="3b1cl3dxdf6kq">
          {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-5 w-5 fill-gold text-gold" aria-hidden="true" data-id="element-137" data-mp="3700pmrrtfr4m" />)}
        </div>
        <SectionHeading title="Lo que nos han compartido mamás “ESCUDO”" subtitle="Madres cansadas de lidiar con el ciclo infinito de mocos, que han elevado la protección de sus hijos." data-id="element-138" data-mp="31z3ayp60lf7v" />
      </Reveal>

      <div className="mx-auto mt-10 grid max-w-md items-start gap-6 md:max-w-4xl md:grid-cols-2" data-id="element-139" data-mp="2s308tjb5xgkx">
        {testimonials.map((t, i) => <Reveal key={t.id} delay={i * 0.05} data-id="element-140" data-mp="v7c9be7wbjt3" data-mpi={i}>
            <figure className="rounded-3xl border border-sage/50 bg-[#FFFDF8] p-2 shadow-soft sm:p-2.5" data-id="element-141" data-mp="qa3pl973n7pq">
              {t.image ? <img src={t.image} alt={t.alt} loading="lazy" className="block h-auto w-full rounded-2xl" data-id="element-142" data-mp="h4wysdjfawnh" /> : <div className="flex aspect-[4/5] flex-col items-center justify-center gap-3 rounded-2xl border-2 border-dashed border-sage-light bg-cream text-ink-muted sm:aspect-[4/3]" data-id="element-143" data-mp="m62o01dvk1s9">
                  <ImageIcon className="h-8 w-8 text-sage" strokeWidth={1.5} aria-hidden="true" data-id="element-144" data-mp="c623wd86lhn0" />
                  <span className="text-sm font-medium" data-id="element-145" data-mp="zw64ebq2p19s">Captura de testimonio</span>
                </div>}
            </figure>
          </Reveal>)}
      </div>
    </section>;
}